// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-d185b43a] .el-table .cur-user-row {\n  background-color: rgb(255, 241, 231);\n}\n", ""]);
// Exports
module.exports = exports;
